// extracted by mini-css-extract-plugin
export var container = "styles-module--container--5fcef";
export var ratioProvider = "styles-module--ratioProvider--744cf";
export var videoContainer = "styles-module--videoContainer--ea57e";